import { render, staticRenderFns } from "./cadespeciespet.vue?vue&type=template&id=70ab0f78&"
import script from "./cadespeciespet.vue?vue&type=script&lang=js&"
export * from "./cadespeciespet.vue?vue&type=script&lang=js&"
import style0 from "./cadespeciespet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports